export default __webpack_public_path__ + "static/media/noun-checkin.3dca4911.svg";